<app-summary-field *ngIf="entity">
    <a (click)="redirect()">
        <span>{{title}}</span>
        <app-date-label [date]="entity.date"></app-date-label>
        - {{entity.partner.name}} -
        <app-price-label [price]="entity.totalPriceVatIncluded"></app-price-label>
    </a>
</app-summary-field>